const seasonPlanService = require('seasonPlanService'),
  calendarService = require('calendarService'),
  flickity = require('flickity'),
  picker = require('picker'),
  pickadate = require('pickadate'),
  pickatime = require('pickatime'),
  modal = require('modal');

const questionnaire = (function() {
  const $questionnaireCarousel = $('.questionnaire .flickity-carousel-outer');
  let flickityData = '';
  let startDate = '';
  let teamID = '';
  let calendarCreateCounter = 0;

  const datePickerOptions = {
    container: 'body',
    formatSubmit: 'dd/mm/yyyy',
    hiddenName: true,
    onSet(context) {
      if (Object.prototype.hasOwnProperty.call(context, 'clear')) {
        undoStepComplete();
      }
    },
  };

  const checkIfTeamsExist = function() {
    if ($('#team-select option').not(':disabled').length === 0) {
      $('window').modal({
        title: 'No teams available',
        content: "<p>You don't have any teams available to choose from. This could be because don't have any teams created or that all of your teams already have a Season Plan assigned.</p><p>Please <a href='mailto:help@thecoachingmanual.com?subject=No teams available when creating Season Plan'>contact us</a> if there are any issues.",
        confirmText: 'Go to Locker',
        cancelText: false,
        complete() {
          window.location.href = '/locker';
        },
      });
    }
  };


  const buildCarousel = function() {
    $questionnaireCarousel.flickity({
      draggable: false,
      prevNextButtons: false,
    });

    flickityData = $questionnaireCarousel.data('flickity');
    updateCurrentSlide();
  };


  const datePickerStart = function() {
    const datePickerStartSpecific = {
      onSet(context) {
        startDate = new Date(context.select); // Need to get the startDate as a variable as we use it to set the min value on the end date picker

        if (Object.prototype.hasOwnProperty.call(context, 'clear')) {
          undoStepComplete();
        }
      },
    };
    const datePickerStartOptions = $.extend({}, datePickerOptions, datePickerStartSpecific);

    $('.datepicker-start').pickadate(datePickerStartOptions);
  };


  const startDateCompleted = function() {
    $('.question-start-date .next-btn').on('click', function() {
      const datePickerEndSpecific = { min: startDate };
      const datePickerEndOptions = $.extend({}, datePickerOptions, datePickerEndSpecific);

      $('.datepicker-end').pickadate(datePickerEndOptions);

      // Reset Plan end date
      const datePickerEnd = $('.datepicker-end').pickadate('picker');
      datePickerEnd.set('min', startDate);
      datePickerEnd.$node.val('');
      $('.datepicker-end').closest('.question-inner').find('.next-btn').removeClass('step-complete');
    });
  };


  const updateCurrentSlide = function() {
    const currentSlideNumber = flickityData.selectedIndex + 1;
    const prevSlideNumber = flickityData.selectedIndex;

    $('.slide-count').html(`Step <span>${currentSlideNumber} of ${flickityData.slides.length}</span>`);
    $(`.flickity-page-dots > li:nth-child(${prevSlideNumber})`).addClass('question-complete');

    calendarAnimation(flickityData);
  };


  const navClick = function() {
    $('.prev-next-btns .btn').on('click', function(e) {
      e.preventDefault();
      if ($(this).hasClass('next-btn')) {
        $questionnaireCarousel.flickity('next');
      } else if ($(this).hasClass('prev-btn')) {
        $questionnaireCarousel.flickity('previous');
      }

      updateCurrentSlide();
    });
  };


  const inputChange = function() {
    $('.questions').find('select, input').on('change', function() {
      if ($(this).hasClass('training-day')) {
        const $selectedTrainingDay = $(this);
        const selectedCheckbox = this;

        trainingDays($selectedTrainingDay, selectedCheckbox);
      } else {
        stepComplete();
      }
    });
  };


  const stepComplete = function() {
    $('.question.is-selected .next-btn').addClass('step-complete');
  };


  const undoStepComplete = function() {
    $('.question.is-selected .next-btn').removeClass('step-complete');
  };


  const trainingDays = function($selectedTrainingDay, selectedCheckbox) {
    const trainingLimit = 3;
    if ($('input.training-day:checked').length > trainingLimit) {
      selectedCheckbox.checked = false;
    }

    if (selectedCheckbox.checked) {
      trainingDayTime($selectedTrainingDay);
    } else {
      // Reset the training time if the day is unchecked
      $selectedTrainingDay.attr('data-training-time', '');
      $selectedTrainingDay.parent().find('.training-time').html('');

      // If no days are now selected, remove the next question link
      if (!$('.question-training-days input:checked').length) {
        undoStepComplete();
      }
    }
  };


  const trainingDayTime = function($selectedTrainingDay) {
    $('window').modal({
      title: 'What time do you train on this day?',
      content: '<p>This step is optional. Selecting a time will allow training reminders to be sent to your players.</p><input class="training-timepicker input-lg" type="time" placeholder="Pick a time (optional)">',
      confirmText: 'Confirm training time',
      disableConfirm: true,
      cancelText: 'Skip',
      complete() {
        // We show the time as AM/PM, but the time that needs to be sent to the API is 24 hour, so we need to get both formats
        const prettyTrainingTime = $('.modal .training-timepicker').val();
        const submitTrainingTime = $('.modal .training-timepicker').next('input[type=hidden]').val();

        $selectedTrainingDay.attr('data-training-time', submitTrainingTime);
        $selectedTrainingDay.parent().find('.training-time').html(prettyTrainingTime);
        stepComplete();
      },
      cancel() {
        stepComplete();
      },
    });

    $('.training-timepicker').pickatime({
      container: 'body',
      format: 'h:i A',
      formatSubmit: 'HH:i',
      hiddenName: true,
      interval: 15,
    });
  };


  const calendarAnimation = function(_flickityData) {
    if (_flickityData.selectedElement.classList.contains('generating-slide')) {
      setTimeout(fadeOutUI, 500);
    }

    function fadeOutUI() {
      $('.section-heading, .slide-count, .flickity-page-dots, .view-more-link, .logo-link').fadeOut('slow', function() {
        setTimeout(showCalendarAnimation, 300);
      });
    }

    function showCalendarAnimation() {
      $('body').addClass('generating-sp');
      monthOneAnimation();
    }

    function monthOneAnimation() {
      $('.sp-calendar-animation .slide').addClass('trigger-one').removeClass('trigger-three');
      setTimeout(monthTwoAnimation, 3000);
    }

    function monthTwoAnimation() {
      $('.sp-calendar-animation .slide').addClass('trigger-two').removeClass('trigger-one');
      setTimeout(monthThreeAnimation, 3000);
    }

    function monthThreeAnimation() {
      $('.sp-calendar-animation .slide').addClass('trigger-three').removeClass('trigger-two');
      setTimeout(monthOneAnimation, 400);
    }
  };


  const generateClick = function() {
    $('.generate-btn').on('click', function() {
      if (this.disabled === false) {
        this.disabled = true;
        const clubID = $('#team-select option:selected').attr('data-club-id');
        const seasonStartDate = $('#start-date').next('input[type=hidden]').val();
        const seasonEndDate = $('#end-date').next('input[type=hidden]').val();
        const teamAge = $('#team-age option:selected').val();
        const trainingTimes = [];
        let matchDay = 5; // default to Saturday

        teamID = $('#team-select option:selected').val(); // teamID already defined as we need to use it in the success response

        $('input[name="training-days"]:checked').each(function () {
          const trainingDay = $(this).val();
          const trainingTime = $(this).attr('data-training-time');
          const obj = { day: trainingDay, time: trainingTime };

          trainingTimes.push(obj);
        });

        $('input[name="matchdays"]:checked').each(function () {
          matchDay = $(this).val();
        });

        assignSeasonPlanService(clubID, teamID, seasonStartDate, seasonEndDate, teamAge, trainingTimes, matchDay, assignResponse);
      }
    });
  };


  const assignResponse = function(response) {
    if (response.statusCode === 201) {
      window.location = "/locker/seasonplan/" + String(teamID);
    } else if (response.statusCode === 200) {
      setTimeout(doesCalendarExist, 5000);
    } else {
      $('window').notification({
        title: response.message,
        error: true,
      });
    }
  };


  const doesCalendarExist = function() {
    if (calendarCreateCounter < 10) {
      doesCalendarExistService(teamID, existsLoop);
    } else {
      $(window).modal({
        confirmText: 'Go to Locker',
        cancelText: false,
        title: 'Your Season Plan is taking longer than expected to build',
        content: "<p>We are currently building your Season Plan but it is taking longer than expected. In the meantime you are able to navigate away from this page and browse the rest of The Coaching Manual. Once built, you should see your new Season Plan under the 'Season Plans' tab in the Locker.</p>",
        complete() {
          window.location.href = '/locker';
        },
      });
    }

    function existsLoop(response) {
      if (response.statusCode === 200) {
        window.location.href = `/locker/seasonplan/${teamID}`;
      } else {
        calendarCreateCounter += 1;
        setTimeout(doesCalendarExist, 1000);
      }
    }
  };


  const init = function() {
    if ($questionnaireCarousel.length) {
      checkIfTeamsExist();
      buildCarousel();
      datePickerStart();
      startDateCompleted();
      navClick();
      inputChange();
      generateClick();
    }
  };

  return {
    init,
  };
}());

questionnaire.init();



// WEBPACK FOOTER //
// ./library/js/modules/questionnaire.js